import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyBIZ_-MxpmETQlLU97RIoVGE-aftK6gWc4",
  authDomain: "miyazaki-quiz-history.firebaseapp.com",
  projectId: "miyazaki-quiz-history",
  storageBucket: "miyazaki-quiz-history.firebasestorage.app",
  messagingSenderId: "956412760163",
  appId: "1:956412760163:web:3b5a005c59e02631432856"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
